module.exports = __webpack_public_path__ + "static/media/(V)-Artesanato-05.24526a19.jpg";